import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import moment from "moment";

//Components
import CustomMap from "../../../../components/CustomMap";
import ModalCustomized from "../../../../components/Modal/Modal";
import TextField from "../../../../components/TextField";

//Context
import { useAuth } from "../../../../context/auth";

//Api
import mapeamentoArboreo_api from "../../../../api/mapeamentoArboreo_api";
import especie_api from "../../../../api/especie_api";
import cep_api from "../../../../api/cep_api";

//Helpers
import { showMessage, showQuestion } from "../../../../helpers/message";
import { validarCampos, objCampo } from "../../../../helpers/ValidadorDeCampos";
import mascaras from "../../../../helpers/mascaras";

//Assets
import { iconeSimples } from "../../../../assets/Icons/Icons";

function initialStateArvore() {
    return {
        especie_Id: null,
        foto: "",
        dataCadastro: "",
        latitude: "",
        Longitude: "",
        cep: "",
        logradouro: "",
        bairro: "",
        numeroLogradouro: "",
        cidade: "",
        uf: "",
    }
}
export default function MapeamentoArboreo({ permissoes }) {
    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //campos obrigatorios
    const campos = [
        objCampo({ name: "especie_Id", required: true }),
        objCampo({ name: "foto", required: true })
    ]

    //Estado de controle para inserção de um item no mapeamento arboreo
    const [arvore, setArvore] = useState(initialStateArvore);

    //Estado de controle da lista de arvores do mapeamento
    const [arvores, setArvores] = useState(null);

    //Estado que guarda a lista de especies
    const [especies, setEspecies] = useState([]);

    //Controle de visibilidade do modal de um item do mapa
    const [visibleModal, setVisibleModal] = useState(false);
    const toggleModal = () => {
        setVisibleModal(!visibleModal)
        if (visibleModal)
            setArvore(initialStateArvore);
    };

    //Controle de visibilidade do modal de inserção de um item no mapa
    const [visibleModalInsert, setVisibleModalInsert] = useState(false);
    const toggleModalInsert = () => {
        setVisibleModalInsert(!visibleModalInsert)
        if (visibleModalInsert) {
            setErrors({});
            setArvore(initialStateArvore);
        }
    };

    const { setLoading } = useAuth();

    const onClickMarker = (marker) => {
        setArvore(marker);
        toggleModal();
    }

    //Carrega a lista de pontos do mapeamento
    const loadMapeamento = () => {
        setLoading(true);
        mapeamentoArboreo_api.getList().then(response => {
            response.data = response.data.map(value => {
                value.coordenadas = [parseFloat(value.latitude), parseFloat(value.longitude)];
                return value;
            })
            setArvores(response.data);
        }).catch(ex => showMessage("Erro", ex.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Insere um item no mapa
    const onSubmit = () => {
        const _errors = validarCampos(arvore, campos);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        const _arvore = { ...arvore };
        _arvore.cep = mascaras.cepMask(_arvore.cep, true);
        _arvore.dataCadastro = moment().format();

        setLoading(true);
        mapeamentoArboreo_api.post(_arvore).then(response => {
            showMessage("Sucesso", "Arvore adicionada com sucesso!", "success", loadMapeamento);
            toggleModalInsert();
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));

    }

    //onChange para o marker no mapa
    const onSelectLocation = (location) => {
        if (editavel) {
            showQuestion("Adicionar novo ponto?", "Deseja incluir uma nova árvore no mapeamento?", "info",
                (confirmation) => {
                    if (confirmation) {
                        setLoading(true);
                        cep_api.GeoCode({ latitude: location.lat, longitude: location.lng }).then(response => {
                            response.data.uf = response.data.estado;
                            response.data.numeroLogradouro = response.data.numero;
                            response.data.cep = mascaras.cepMask(response.data.cep, true);
                            delete response.data.latitude;
                            delete response.data.longitude;

                            setArvore({
                                ...arvore,
                                ...response.data,
                                ...{ latitude: location.lat, longitude: location.lng }
                            });
                            toggleModalInsert();
                        }).catch(ex => showMessage("Erro", ex.Message, "error", null))
                            .finally(f => setLoading(false));
                    }
                })
        }
    }

    //Função que carrega a lista de especies
    const loadEspecies = () => {
        setLoading(true);
        especie_api.getList("Ativo").then(response => {
            response.data = response.data.map(value => {
                value.id = value.id.toString();
                return value;
            })
            setEspecies(response.data);
        }).catch(e => showMessage("Error", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de onChange do arquivo de anexo
    const onChangeAnexo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            setArvore({
                ...arvore,
                foto: base64,
            });
        });

        FR.readAsDataURL(e.target.files[0]);
    }

    const onChangeEspecie = (value, e) => {

        setArvore({
            ...arvore,
            especie_Id: value ? value.value : null
        })
    }
    useEffect(() => {
        loadMapeamento();
        loadEspecies();
    }, []);

    return (
        <>
            <ModalCustomized btnClose={true} isOpen={visibleModalInsert} toggle={toggleModalInsert} title={"+ Adicionar"}>
                <Row>
                    <Col md="12" lg="12">
                        <p className="text-secondary"><span className="fw-bold">Endereço: </span>{arvore.enderecoFormatado}</p>
                    </Col>
                    <Col md="12" lg="12">
                        <TextField
                            label={"Espécie"}
                            name={"especie_Id"}
                            type={"select"}
                            searchable
                            options={especies.map(value => ({ value: value.id, label: value.identificacao }))}
                            value={especies.filter(value => value.id == arvore.especie_Id).map(value => ({ value: value.id, label: value.identificacao }))}
                            onChange={onChangeEspecie}
                            invalid={!!errors.especie_Id}
                        />
                    </Col>
                    {
                        !!arvore.especie_Id && especies.filter(especie => especie.id == arvore.especie_Id)[0].observacao &&
                        <Col md="12">
                            <p><span className="fw-bold">Observação da espécie:</span> {especies.filter(especie => especie.id == arvore.especie_Id)[0].observacao}</p>
                        </Col>
                    }
                    <Col md="12" lg="12">
                        <TextField label="Foto" name={"foto"} type={"file"} onChange={onChangeAnexo} value={arvore.foto} invalid={!!errors.foto} />
                    </Col>
                    <Col className='d-flex align-items-center justify-content-center' md="12" lg="12">
                        <img className='rounded' src={`${arvore.foto}`} alt="" width={200} />
                    </Col>
                    <Col md="12" lg="12" className="d-flex align-items-center justify-content-center mt-4">
                        <Button onClick={onSubmit} color="success">+ Adicionar</Button>
                    </Col>
                </Row>
            </ModalCustomized>
            <ModalCustomized btnClose={true} isOpen={visibleModal} toggle={toggleModal} title={"Informações da árvore"}>
                <div style={{ color: "#666" }} className="d-flex align-items-center justify-content-center flex-column">
                    <img src={arvore?.foto} width="200" height="200" className="rounded-circle mb-4" />
                    <p><span className="fw-bold">Espécie:</span> {arvore?.especie}</p>
                    <p><span className="fw-bold">Data de cadastro:</span> {moment(arvore?.dataCadastro).format("DD/MM/YYYY HH:mm:ss")}</p>
                </div>
            </ModalCustomized>
            <Row style={{ height: "500px" }}>
                <Col md="12" lg="12" className="rounded overflow-hidden p-0" >
                    <CustomMap
                        onClickMarker={onClickMarker}
                        markers={arvores}
                        addNewMarker
                        setPosition={onSelectLocation}
                        checkLoadingCenter={false}
                        icone={iconeSimples}
                    />
                </Col>
            </Row>
        </>
    )
}